import axios from 'axios';
import { ShippingStoresApiResponse } from './types/shipping-stores';
import { ShippingRouteApiResponse } from './types/shipping-route';
import { ShippingEmailApiBody } from './types/shipping-email';

export async function getStores(): Promise<ShippingStoresApiResponse[]> {
    const stores: ShippingStoresApiResponse[] = [];

    await axios
        .get('/home/api/customershipping/stores')
        .then((response: { data: ShippingStoresApiResponse[] }) => {
            Object.assign(stores, response.data);
        })
        .catch(error => '');

    return stores;
}

export async function getRoutePrice(sourceID: string, destinationID: string): Promise<ShippingRouteApiResponse> {
    const route: ShippingRouteApiResponse = {
        sourceStoreID: '',
        sourceStoreState: '',
        sourceStoreName: '',
        destinationStoreID: '',
        destinationStoreState: '',
        destinationStoreName: '',
        miles: '',
        basePrice: '',
        totalPrice: '',
        azSalesTax: '',
    };

    await axios
        .get(`/home/api/customershipping/routes?sourceStoreID=${sourceID}&destinationStoreID=${destinationID}`)
        .then((response: { data: ShippingRouteApiResponse }) => {
            Object.assign(route, response.data);
        })
        .catch(error => '');

    return route;
}

export async function postShippingOrder(order: ShippingEmailApiBody): Promise<boolean> {
    let success = false;

    await axios
        .post('home/api/customershipping/submit', order)
        .then(() => {
            success = true;
        })
        .catch(error => '');

    return success;
}
